import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { OrganizationsSnapshotModel } from '../_model/organizations-snapshot';

export const useOrganizationsSnapshot = ({
  id,
  params,
}: { id: string | undefined; params: { page: number; pageSize: number } }) => {
  return useQuery({
    queryKey: ['organizations-snapshot', id, params],
    queryFn: async () => {
      const res = await axiosGet(`/api/snapshots/${id}/organizations/`, params);
      return OrganizationsSnapshotModel.parse(res);
    },
    enabled: !!id,
    gcTime: 60 * 60 * 12 * 1000, // 12時間
    staleTime: 60 * 60 * 12 * 1000, // 12時間
  });
};
